import { DisplayText, HeadlineText } from "@classdojo/web/nessie";
import { translate } from "@classdojo/web/utils/translate";
import React from "react";
import TimeInput from "./TimeInput";
import ToolkitModal from "components/ToolkitModal";

type CustomTimeModalProps = {
  startTimer: (input: number) => void;
  goBack: VoidFunction;
};

type CustomTimeModalState = {
  minutes: number;
  seconds: number;
  selected: "minutes" | "seconds";
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class CustomTimeModal extends React.Component<CustomTimeModalProps, CustomTimeModalState> {
  constructor(props: CustomTimeModalProps) {
    super(props);
    this.state = {
      minutes: 0,
      seconds: 0,
      selected: "minutes",
    };
  }

  render() {
    return (
      <ToolkitModal
        primaryButton={{
          text: translate("dojo.beyond:toolkit.timer.start"),
          "data-name": "toolkit.timer.start",
          onClick: this.clickStart,
        }}
        secondaryButton={{
          text: translate("dojo.beyond:toolkit.timer.cancel"),
          "data-name": "toolkit.timer.cancel",
          onClick: this.clickCancel,
        }}
      >
        <HeadlineText as="h2">{translate("dojo.beyond:toolkit.timer.new_timer")}</HeadlineText>
        <div sx={{ display: "flex", flexDirection: "row", margin: "dt_l", position: "relative" }}>
          <TimeInput
            value={this.state.minutes}
            selected={this.state.selected === "minutes"}
            onChange={(minutes) => this.setState({ minutes })}
            onFocus={() => this.setState({ selected: "minutes" })}
          />
          <DisplayText>{":"}</DisplayText>
          <TimeInput
            value={this.state.seconds}
            selected={this.state.selected === "seconds"}
            onChange={(seconds) => this.setState({ seconds })}
            onFocus={() => this.setState({ selected: "seconds" })}
          />
        </div>
      </ToolkitModal>
    );
  }

  clickCancel = () => {
    this.props.goBack();
  };

  clickStart = () => {
    this.props.startTimer(Number(this.state.minutes) * 60 + Number(this.state.seconds));
  };
}
